export default "__VITE_ASSET__DZBIBDen__"